import React, { Component } from 'react'
import {
    Tooltip
} from 'reactstrap';
import { Link } from 'react-router-dom';

class ActionsRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            TooltipDelete: false,
            TooltipUpdate: false,
            TooltipFav: false
        };
    }
    toggleTooltipDelete() {
        this.setState({
            TooltipDelete: !this.state.TooltipDelete
        });
    }
    toggleTooltipUpdate() {
        this.setState({
            TooltipUpdate: !this.state.TooltipUpdate
        });
    }
    toggleTooltipFav() {
        this.setState({
            TooltipFav: !this.state.TooltipFav
        });
    }
    actionUpdate(){
        this.props.actionUpdate(this.props.address)
    }
    actionDelete(){
        this.props.actionDelete(this.props.addressId)
    }
    actionFav(option){
        this.props.actionFav(option, this.props.addressId)
    }
    render(){
        return(
            <div className="btn-group float-right" role="group">
                <button
                    id={"TooltipDelete_" + this.props.addressId}
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={this.actionDelete.bind(this)}
                >
                    <i className="fa fa-remove" />
                    <Tooltip
                        placement="top"
                        isOpen={this.state.TooltipDelete}
                        target={"TooltipDelete_" + this.props.addressId}
                        toggle={this.toggleTooltipDelete.bind(this)}
                    >
                        Borrar dirección
                    </Tooltip>
                </button>
                {!this.props.address.favorite ?
                    <button
                        id={"TooltipFav_" + this.props.addressId}
                        type="button"
                        className="btn btn-sm btn-outline-warning"
                        onClick={this.actionFav.bind(this, true)}
                    >
                        <i className="fa fa-star-o"/>
                        <Tooltip
                            placement="top"
                            isOpen={this.state.TooltipFav}
                            target={"TooltipFav_" + this.props.addressId}
                            toggle={this.toggleTooltipFav.bind(this, false)}
                        >
                            Hacer favorita
                        </Tooltip>
                    </button>
                    :
                    <button
                        id={"TooltipFav_" + this.props.addressId}
                        type="button"
                        className="btn btn-sm btn-outline-warning"
                        onClick={this.actionFav.bind(this, false)}
                    >
                        <i className="fa fa-star"/>
                        <Tooltip
                            placement="top"
                            isOpen={this.state.TooltipFav}
                            target={"TooltipFav_" + this.props.addressId}
                            toggle={this.toggleTooltipFav.bind(this)}
                        >
                            Quitar como favorita
                        </Tooltip>
                    </button>
                }
                <button
                    id={"TooltipUpdate_" + this.props.addressId}
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={this.actionUpdate.bind(this)}
                >
                    <i className="fa fa-edit" />
                    <Tooltip
                        placement="top"
                        isOpen={this.state.TooltipUpdate}
                        target={"TooltipUpdate_" + this.props.addressId}
                        toggle={this.toggleTooltipUpdate.bind(this)}
                    >
                        Editar dirección
                    </Tooltip>
                </button>
            </div>
        )
    }
}
export default ActionsRow


// WEBPACK FOOTER //
// ./resources/assets/js/components/settings/addresses/ActionButtons.jsx